import { Button } from '@/components/ui/Button';
import { Typography } from '@/components/ui/Text';
import clsx from 'clsx';
import { TBlogModuleMidPageCTA } from '../../blog/blog.types';

import './BlogArticleModuleMidPageCallToAction.scss';

type Props = {
  mobile: boolean;
  module: TBlogModuleMidPageCTA;
};

export const BlogArticleModuleMidPageCallToAction: React.FC<Props> = ({
  module,
  mobile,
}) => (
  <div
    className={clsx('BlogArticleModuleMidPageCallToAction', {
      'BlogArticleModuleMidPageCallToAction--desktop': !mobile,
      'BlogArticleModuleMidPageCallToAction--mobile': mobile,
    })}
    style={{ backgroundColor: module.backgroundColor || undefined }}
  >
    <Typography
      className='BlogArticleModuleMidPageCallToAction__title'
      variant='h3-serif'
    >
      {module.title}
    </Typography>

    {module.subtitle && (
      <Typography
        className='BlogArticleModuleMidPageCallToAction__subtitle'
        variant='body'
      >
        {module.subtitle}
      </Typography>
    )}

    <Button
      className='BlogArticleModuleMidPageCallToAction__button'
      href={module.url}
      variant='dark'
    >
      {module.buttonText}
    </Button>
  </div>
);
